var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/blackCheckBox.fc1eb42b.png","uri@2x": __webpack_public_path__ + "static/media/blackCheckBox.eaa9e869.png","uri@3x": __webpack_public_path__ + "static/media/blackCheckBox.f4d07ef3.png",
    width: 18,
    height: 18
});